import { render, staticRenderFns } from "./project_edit.vue?vue&type=template&id=f1c205f0&scoped=true&"
import script from "./project_edit.vue?vue&type=script&lang=js&"
export * from "./project_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c205f0",
  null
  
)

export default component.exports